type AddonVariantWithPremium = {
  price?: {
    net_premium?: number | string | null;
  };
  cover_extras?: {
    net_premium_difference?: number | string | null;
  };
};

export const getVariantStrikeThroughPremium = (
  variant: AddonVariantWithPremium,
  isUpgradeAvailable?: boolean
) => {
  if (!isUpgradeAvailable) {
    return null;
  }

  const netPremiumValue = variant?.price?.net_premium;
  const netPremiumDifferenceValue =
    variant?.cover_extras?.net_premium_difference;

  if (
    netPremiumValue === null ||
    netPremiumValue === undefined ||
    netPremiumDifferenceValue === null ||
    netPremiumDifferenceValue === undefined
  ) {
    return null;
  }

  const netPremium = Number(netPremiumValue);
  const netPremiumDifference = Number(netPremiumDifferenceValue);

  if (
    !Number.isFinite(netPremium) ||
    !Number.isFinite(netPremiumDifference) ||
    netPremiumDifference >= 0
  ) {
    return null;
  }

  return netPremium + Math.abs(netPremiumDifference);
};
